import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import {
    DialogActions,
    DialogContent,
    Paper,
    Grid,
    Checkbox
} from 'material-ui';
import Button from 'material-ui/Button';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import IconButton from 'material-ui/IconButton';
import { FormGroup, FormControl, FormLabel, FormControlLabel, FormHelperText } from 'material-ui/Form';
import { Visibility, VisibilityOff } from 'material-ui-icons';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { getUserInformation } from '../Login/loginService';
import { translate } from 'react-i18next';
import { validatePassword } from '../ChangePassword/ChangePasswordService';
import isEmail from 'validator/lib/isEmail';
import clonedeep from 'lodash.clonedeep';
import { addUser, updateUser } from './userServices';
import { Typography } from '../../../node_modules/material-ui';


const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)'
    }
});

const authorities = [
    {
        'id': 'B2BMisReserva',
        'name': 'USER.BOOKINGS'
    },
    {
        'id': 'B2BMisFacturas',
        'name': 'USER.INVOICES'
    },
    {
        'id': 'B2BMiAgencia',
        'name': 'USER.AGENCIES'
    },
    {
        'id': 'B2BUsuariosAgencia',
        'name': 'USER.USERS'
    },
    {
        'id': 'B2BMisDatos',
        'name': 'USER.PROFILE'
    },
];

/**
 * 
 */
class UserAddDialog extends React.Component {
    constructor(props) {
        super(props);

        this.currentUser = getUserInformation();

        this.state = {
            user: {
                id: '',
                firstName: '',
                email: '',
                jobTitle: '',
                userName: '',
                language: this.currentUser.user_detail.language,
                password: '',
                confirmPassword: '',
                authorities: clonedeep(this.currentUser.authorities)
            },
            isEditing: false,
            success: false,
            loading: false,
            failedFirstName: true,
            failedEmail: true,
            failedUserName: true,
            failedPassword: true,
            selectUserAuth: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const blankuser = {
            id: '',
            firstName: '',
            email: '',
            jobTitle: '',
            userName: '',
            language: this.currentUser.user_detail.language,
            password: '',
            confirmPassword: '',
            authorities: clonedeep(this.currentUser.authorities)
        };

        const edituser = clonedeep(nextProps.user);

        this.setState({
            user: edituser ? edituser : blankuser,
            isEditing: edituser ? true : false,
            success: false,
            loading: false,
            failedFirstName: !edituser,
            failedEmail: !edituser,
            failedUserName: !edituser,
            failedPassword: !edituser,
            selectUserAuth: false
        });
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true });
        }

        if (!this.state.isEditing) {
            this.addUser().then(result => {
                if (result.errorCode && result.errorCode !== 201) {
                    this.setState({
                        success: false,
                        loading: false
                    });

                    let message = result.message;
                    if (result.detailedMessage) {
                        message += '\n' + result.detailedMessage;
                    }

                    alert(message);
                }
                else {

                    this.setState({ success: true, loading: false });
                    this.props.onClose(true);
                }
            });
        }
        else {
            this.updateUser().then(result => {
                if (!result.errorCode) {
                    this.setState({ success: true, loading: false });
                    this.props.onClose(true);
                }
                else {
                    this.setState({
                        success: false,
                        loading: false
                    });
                    let message = result.message;
                    if (result.detailedMessage) {
                        message += '\n' + result.detailedMessage;
                    }
                    alert(message);

                }
            });
        }
    };

    addUser = async () => {
        try {
            return await addUser(this.state.user);
        } catch (error) {
            return error;
        }
    };

    updateUser = async () => {
        try {
            return await updateUser(this.state.user);
        } catch (error) {
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    handlePasswordChange(data) {
        let user = this.state.user;
        user['password'] = data;
        this.setState({ user });
        this.validatePassword();
    }

    handleConfirmPasswordChange(data) {
        let user = this.state.user;
        user['confirmPassword'] = data;
        this.setState({ user });
        this.validatePassword();
    }

    validatePassword() {
        const validationResult = validatePassword(this.state.user.password,
            this.state.user.confirmPassword);

        this.setState({
            failedPassword: validationResult.failed,
            message: validationResult.message
        });
    }

    handlefirstNameChange(data) {
        let useraux = this.state.user;
        useraux['firstName'] = data;
        this.setState({
            user: useraux,
            failedFirstName: (data.length === 0),
        });
    }

    handleEmailChange(data) {
        let useraux = this.state.user;
        useraux['email'] = data;
        this.setState({
            user: useraux,
            failedEmail: !isEmail(data),
        });
    }

    handleJobTitleChange(data) {
        let useraux = this.state.user;
        useraux['jobTitle'] = data;
        this.setState({
            user: useraux,
        });
    }

    handleUserNameChange(data) {
        let useraux = this.state.user;
        useraux['userName'] = data;
        this.setState({
            user: useraux,
            failedUserName: (data.length === 0),
        });
    }

    handleAuthoritiesChange = index => event => {
        let useraux = this.state.user;

        const authority = authorities[index];
        const checked = event.target.checked;
        const pos = useraux.authorities.indexOf(authority.id);
        const userHasAuthority = (pos > -1);

        if (checked) {
            if (!userHasAuthority) {
                useraux.authorities.push(authority.id);
            }
        }
        else {
            if (userHasAuthority) {
                useraux.authorities.splice(pos, 1);
            }
        }

        this.setState({
            user: useraux,
            selectUserAuth: true
        });
    }

    renderAuthorities() {
        const { t } = this.props;
        let currentUserAuthorities = this.state.user.authorities;

        return (
            <FormControl fullWidth style={{ marginTop: '20px' }}>
                <FormLabel component="legend">{t('USER.AUTHORITIES')}</FormLabel>
                <FormGroup row>
                    {authorities
                        ? authorities.map((authority, index) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={currentUserAuthorities.indexOf(authority.id) > -1}
                                        onChange={
                                            this.handleAuthoritiesChange(index)}
                                        value={authority.id}
                                    />
                                }
                                label={t(authority.name)}
                            />
                        ))
                        : ''
                    }
                </FormGroup>
            </FormControl>
        );
    }

    disableAddButton = () => {
        const { failedFirstName, failedEmail, failedUserName, failedPassword } = this.state;
        return failedFirstName || failedEmail || failedUserName || failedPassword;
    }

    render() {

        const { classes, title, t, ...other } = this.props;

        if (!this.state)
            return '';

        const {
            loading,
            isEditing,
            failed,
            failedFirstName,
            failedEmail,
            failedUserName,
            failedPassword,
            message } = this.state;

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="user-add-dialog"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle
                    id="user-add-dialog"
                    disableTypography={true}
                    className={classes.dialogTitle}>
                    {isEditing ? t('USER.EDIT_USER_TITLE') : t('USER.ADD_USER_TITLE')}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ padding: '12px' }} elevation={0}>
                        <FormControl fullWidth error={failedUserName}>
                            <InputLabel htmlFor="userName" className={classes.inputLabel} shrink={true} >
                                {t('USER.USER_NAME')} *
                            </InputLabel>
                            <Input
                                id="userName"
                                value={this.state.user.userName}
                                disabled={isEditing}
                                placeholder={t('USER.USER_NAME')}
                                onChange={event => {
                                    this.handleUserNameChange(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <span></span>
                        <Grid
                            container
                            direction={'row'}
                            alignItems={'baseline'}
                            style={{ marginTop: '10px' }}
                        >
                            <Grid item xs={6} style={{ height: '80px' }}>
                                <FormControl fullWidth error={failedEmail}>
                                    <InputLabel htmlFor="userEmail" className={classes.inputLabel} shrink={true} >
                                        {t('USER.EMAIL')}  *
                                    </InputLabel>
                                    <Input
                                        id="userEmail"
                                        value={this.state.user.email}
                                        placeholder={t('USER.EMAIL')}
                                        onChange={event => {
                                            this.handleEmailChange(String(event.target.value));
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} style={{ height: '80px' }}>
                                <FormControl fullWidth >
                                    <InputLabel htmlFor="userJobTitle" className={classes.inputLabel} shrink={true} >
                                        {t('USER.JOB_TITLE')}
                                    </InputLabel>
                                    <Input
                                        id="userJobTitle"
                                        value={this.state.user.jobTitle}
                                        placeholder={t('USER.JOB_TITLE')}
                                        onChange={event => {
                                            this.handleJobTitleChange(String(event.target.value));
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <span></span>
                        <Grid
                            container
                            direction={'row'}
                            alignItems={'baseline'}
                            style={{ paddingTop: '10px', paddingBottom: '10px' }}
                        >
                            <Grid item xs={12} style={{ height: '50px' }}>
                                <FormControl fullWidth error={failedFirstName}>
                                    <InputLabel htmlFor="userFirstName" className={classes.inputLabel} shrink={true} >
                                        {t('USER.FIRST_NAME')} *
                                    </InputLabel>
                                    <Input
                                        id="userName"
                                        value={this.state.user.firstName}
                                        placeholder={t('USER.FIRST_NAME')}
                                        onChange={event => {
                                            this.handlefirstNameChange(String(event.target.value));
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <span></span>
                        {isEditing ? '' :
                            (<Grid
                                container
                                direction={'row'}
                                alignItems={'baseline'}
                                style={{ paddingBottom: '10px', marginTop: '10px' }}>
                                <Grid item xs={6} style={{ height: '50px' }}>
                                    <FormControl fullWidth error={failedPassword}>
                                        <InputLabel htmlFor="userPassword" className={classes.inputLabel} shrink={true} >
                                            {t('USER.PASSWORD')} *
                                        </InputLabel>
                                        <Input
                                            id="userPassword"
                                            type={this.state.showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                                    >
                                                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            placeholder={t('USER.PASSWORD')}
                                            onChange={event => {
                                                this.handlePasswordChange(String(event.target.value));
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} style={{ height: '50px' }}>
                                    <FormControl fullWidth error={failedPassword}>
                                        <InputLabel htmlFor="confirmPassword" className={classes.inputLabel} shrink={true} >
                                            {t('USER.CONFIRM_PASSWORD')} *
                                        </InputLabel>
                                        <Input
                                            id="userConfirmPassword"
                                            type={this.state.showConfirmPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                                                    >
                                                        {this.state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            placeholder={t('USER.CONFIRM_PASSWORD')}
                                            onChange={event => {
                                                this.handleConfirmPasswordChange(String(event.target.value));
                                            }}
                                        />
                                    </FormControl>

                                </Grid>

                                <Grid item xs={12} style={{ height: '10px' }}>

                                    {failedPassword ? (
                                        <FormHelperText
                                            style={{
                                                fontSize: '14px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {t(message)}
                                        </FormHelperText>
                                    ) : (
                                        ''
                                    )}
                                </Grid>
                            </Grid>
                            )}
                        <span></span>
                        {/* OLYB2B-761: se pide que se saque esta funcionalidad.
                         <Grid
                            container
                            direction={'row'}
                            alignItems={'baseline'}
                            style={{paddingBottom: '10px', marginTop: '10px'}}>
                            <Grid item xs={6} style={{height: '50px'}}>
                                <DropDownMenu
                                    width={'100%'}
                                    label={t('USER.LANGUAGE')}
                                    selection={this.state.user.language}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.inputLabel
                                    }}
                                    onChange={value => {
                                        let user = this.state.user;
                                        user.language = String(value);
                                        this.setState({user:user});
                                    }}
                                    menuOptions={[
                                        { label: t('LANG.ES'), value: 'ES' },
                                        { label: t('LANG.PT'), value: 'PT' },
                                        { label: t('LANG.EN'), value: 'EN' }
                                    ]}
                                />
                            </Grid> */}
                        {/* </Grid> */}
                        <br /><br />
                        <Typography variant='caption'>{t('CONFIRM_BOOKING.REQUIRED_FIELDS')}</Typography>
                        {
                            this.renderAuthorities()
                        }
                        <span></span>
                        {failed ? (
                            <FormHelperText>{t(message)}</FormHelperText>
                        ) : (
                            ''
                        )}
                    </Paper>

                </DialogContent>

                <DialogActions className={classes.root} style={{ padding: '12px' }}>
                    <div className={classes.wrapper}>
                        <Button
                            disabled={loading}
                            onClick={this.handleCancel}>
                            {t('USER.CANCEL_BUTTON')}
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={loading || this.disableAddButton()}
                            onClick={this.handleClose}>
                            {isEditing ? t('USER.SAVE_BUTTON') : t('USER.ACCEPT_BUTTON')}
                        </Button>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

UserAddDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(UserAddDialog));



// WEBPACK FOOTER //
// ./src/components/User/UserAddDialog.js